/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import './InstructorExamGrading.css';
import { apiFetch } from './api';
import MathText from './MathText';
import logoImg from './logo.png';

const PDF_CONST = {
  MARGIN: 10, PAGE_H: 297, PAGE_W: 210,
  RENDER_PX_W: 714, COL_GAP: 4,
  get CONTENT_W() { return this.PAGE_W - this.MARGIN * 2; },
  get COL_W()     { return (this.CONTENT_W - this.COL_GAP) / 2; },
  get HALF_PX()   { return Math.floor(this.RENDER_PX_W / 2); },
};

const PDF_STYLE = `
  .pdf-render-root *{box-sizing:border-box;margin:0;padding:0;font-family:Arial,sans-serif}
  .pdf-render-root{font-family:Arial,sans-serif;color:#111;background:#fff}
  .pdf-header{border-bottom:3px double #1a3a5c;padding-bottom:14px;margin-bottom:6px}
  .pdf-header-top{display:flex;justify-content:space-between;align-items:center;margin-bottom:10px}
  .pdf-univ-block{display:flex;flex-direction:column}
  .pdf-univ-name{font-size:13pt;font-weight:700;color:#1a3a5c;letter-spacing:.5px}
  .pdf-univ-sub{font-size:9pt;color:#4b5563;margin-top:2px}
  .pdf-logo-block img{height:56px;object-fit:contain}
  .pdf-doc-title{text-align:center;font-size:15pt;font-weight:700;color:#1a3a5c;letter-spacing:1px;text-transform:uppercase;padding:10px 0 6px}
  .pdf-meta-table{width:100%;border-collapse:collapse;margin-bottom:4px}
  .pdf-meta-table td{padding:5px 10px;font-size:9pt;border:1px solid #cbd5e1;vertical-align:top}
  .pdf-meta-table .lbl{font-weight:700;color:#1a3a5c;width:90px;background:#f1f5f9;white-space:nowrap}
  .pdf-meta-table .val{color:#111}
  .pdf-header-band{background:#1a3a5c;color:#fff;text-align:center;padding:6px 0;font-size:10pt;font-weight:700;letter-spacing:1px;margin:10px 0 0}
  .pdf-question{border:none;border-radius:0;padding:10px 12px;margin-bottom:8px;background:#fff}
  .pdf-question-topbar{display:flex;justify-content:space-between;align-items:center;margin-bottom:6px;padding-bottom:5px;border-bottom:1px solid #e2e8f0}
  .pdf-question-badge{background:#1a3a5c;color:#fff;border-radius:3px;padding:2px 8px;font-size:8.5pt;font-weight:700}
  .pdf-question-score{font-size:9pt;font-weight:700;color:#1a3a5c}
  .pdf-question-text{font-size:10pt;line-height:1.6;color:#111;margin-bottom:8px}
  .pdf-classic-answer{background:#f8fafc;border:1px solid #e2e8f0;border-left:3px solid #1a3a5c;padding:6px 10px;font-size:9.5pt;line-height:1.5;white-space:pre-wrap;color:#374151;margin-top:4px}
  .pdf-correct-label{font-size:8.5pt;color:#1a7a1a;margin-top:5px;font-weight:700}
  .pdf-page-break{height:0}
`;

function InstructorExamGrading({ examId, instructorId, onBack }) {
  const [submissions, setSubmissions] = useState([]);
  const [selectedSubmission, setSelectedSubmission] = useState(null);
  const [submissionDetail, setSubmissionDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [error, setError] = useState('');
  const [grading, setGrading] = useState({}); // {attempt_question_id: manual_points}
  const [saving, setSaving] = useState(false);
  const [publishing, setPublishing] = useState(false);
  const [correctAnswerEdits, setCorrectAnswerEdits] = useState({}); // {question_id: "A"}
  const [savingCorrectAnswer, setSavingCorrectAnswer] = useState({}); // {question_id: boolean}
  const [markingAllGraded, setMarkingAllGraded] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [pdfLoading, setPdfLoading] = useState(false);
  const [pdfProgress, setPdfProgress] = useState({ done: 0, total: 0 });
  useEffect(() => {
    if (examId) {
      fetchSubmissions();
    }
  }, [examId]);

  // Otomatik yenileme - 30 saniyede bir sessiz güncelleme
  useEffect(() => {
    if (!examId) return;
    
    const interval = setInterval(() => {
      // Sessiz güncelleme - loading state'i değiştirme
      fetchSubmissions(true).catch(err => console.error('Otomatik yenileme hatası:', err));
    }, 30000); // 30 saniye

    return () => clearInterval(interval);
  }, [examId]);

  const fetchSubmissions = async (silent = false) => {
    try {
      if (!silent) {
        setLoading(true);
      }
      const response = await apiFetch(`/instructor/exams/${examId}/submissions`);
      const data = await response.json();

      if (data.success) {
        setSubmissions(data.submissions || []);
      } else {
        if (!silent) {
          setError(data.message || 'Sınav kağıtları yüklenemedi');
        }
      }
    } catch (err) {
      if (!silent) {
        setError('Bağlantı hatası');
      }
      console.error('Error:', err);
    } finally {
      if (!silent) {
        setLoading(false);
      }
    }
  };

  const fetchSubmissionDetail = async (attemptId) => {
    try {
      setLoadingDetail(true);
      const response = await apiFetch(`/instructor/exams/${examId}/submissions/${attemptId}`);
      const data = await response.json();

      if (data.success) {
        setSubmissionDetail(data.submission);
        // Mevcut manuel puanları olduğu gibi yükle
        const gradingData = {};
        data.submission.questions.forEach(q => {
          if (q.points.manual_points !== null && q.points.manual_points !== undefined) {
            gradingData[q.attempt_question_id] = q.points.manual_points;
          }
        });
        setGrading(gradingData);
      } else {
        alert(data.message || 'Sınav kağıdı detayı yüklenemedi');
      }
    } catch (err) {
      alert('Bağlantı hatası');
      console.error('Error:', err);
    } finally {
      setLoadingDetail(false);
    }
  };

  const handleGradeChange = (attemptQuestionId, value) => {
    setGrading(prev => ({
      ...prev,
      [attemptQuestionId]: value === '' ? null : parseFloat(value)
    }));
  };

  const saveCorrectAnswer = async (questionId, attemptId) => {
    const selectedAnswer = correctAnswerEdits[questionId];
    if (!selectedAnswer) {
      alert('Lütfen doğru cevabı seçin');
      return;
    }
    try {
      setSavingCorrectAnswer(prev => ({ ...prev, [questionId]: true }));
      const response = await apiFetch(
        `/instructor/exams/${examId}/questions/${questionId}/set-correct-answer`,
        { method: 'POST', body: JSON.stringify({ correct_answer: selectedAnswer }) }
      );
      const data = await response.json();
      if (data.success) {
        alert(data.message || 'Doğru cevap kaydedildi');
        setCorrectAnswerEdits(prev => { const next = { ...prev }; delete next[questionId]; return next; });
        await fetchSubmissionDetail(attemptId);
        await fetchSubmissions();
      } else {
        alert(data.message || 'Doğru cevap kaydedilemedi');
      }
    } catch (err) {
      alert(err.message || 'Bağlantı hatası');
    } finally {
      setSavingCorrectAnswer(prev => ({ ...prev, [questionId]: false }));
    }
  };

  const saveAllGrades = async (attemptId) => {
    // Tüm puanları topla
    const grades = [];
    if (submissionDetail && submissionDetail.questions) {
      for (const q of submissionDetail.questions) {
        const manualPoints = grading[q.attempt_question_id];
        if (manualPoints !== null && manualPoints !== undefined && manualPoints !== '') {
          grades.push({
            attempt_question_id: q.attempt_question_id,
            manual_points: parseFloat(manualPoints)
          });
        }
      }
    }

    if (grades.length === 0) {
      alert('Kaydedilecek puan bulunamadı');
      return;
    }

    try {
      setSaving(true);
      const response = await apiFetch(
        `/instructor/exams/${examId}/submissions/${attemptId}/grade-bulk`,
        {
          method: 'POST',
          body: JSON.stringify({
            grades: grades
          })
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: 'Sunucu hatası' }));
        alert(errorData.message || `Hata: ${response.status}`);
        return;
      }

      const data = await response.json();
      if (data.success) {
        alert(`Tüm puanlar kaydedildi (${grades.length} soru)`);
        // Detayı yenile
        await fetchSubmissionDetail(attemptId);
        // Listeyi yenile
        await fetchSubmissions();
      } else {
        alert(data.message || 'Puanlar kaydedilemedi');
      }
    } catch (err) {
      console.error('Error:', err);
      alert(err.message || 'Bağlantı hatası. Lütfen tekrar deneyin.');
    } finally {
      setSaving(false);
    }
  };

  const markAllGraded = async () => {
    const pendingCount = submissions.filter(s => !s.is_graded).length;
    if (pendingCount === 0) {
      alert('Tüm öğrenciler zaten puanlandı.');
      return;
    }
    const confirmed = window.confirm(
      `${pendingCount} beklemedeki öğrencinin değerlendirilmemiş klasik sorularına 0 puan verilecek ve puanlandı olarak işaretlenecek. Devam etmek istiyor musunuz?`
    );
    if (!confirmed) return;

    try {
      setMarkingAllGraded(true);
      const response = await apiFetch(`/instructor/exams/${examId}/mark-all-graded`, { method: 'POST' });
      const data = await response.json();
      if (data.success) {
        alert(data.message || 'Tüm öğrenciler puanlandı olarak işaretlendi.');
        await fetchSubmissions();
        // fetchSubmissions sonrası hala beklemede görünüyorsa state'i zorla güncelle
        setSubmissions(prev => prev.map(s => ({ ...s, is_graded: true })));
      } else {
        alert(data.message || 'İşlem başarısız.');
      }
    } catch (err) {
      alert('Bağlantı hatası');
      console.error('Error:', err);
    } finally {
      setMarkingAllGraded(false);
    }
  };

  const publishResults = async () => {
    // Tüm sınav kağıtlarının değerlendirilip değerlendirilmediğini kontrol et
    const allGraded = submissions.every(sub => sub.is_graded);
    if (!allGraded) {
      alert('Tüm sınav kağıtları değerlendirilmeden sonuçlar yayınlanamaz');
      return;
    }

    const confirmPublish = window.confirm('Sonuçları yayınlamak istediğinize emin misiniz? Bu işlem geri alınamaz.');
    if (!confirmPublish) {
      return;
    }

    try {
      setPublishing(true);
      const response = await apiFetch(
        `/instructor/exams/${examId}/publish-results`,
        {
          method: 'POST'
        }
      );

      const data = await response.json();
      if (data.success) {
        alert('Sonuçlar başarıyla yayınlandı');
        if (onBack) {
          onBack();
        }
      } else {
        alert(data.message || 'Sonuçlar yayınlanamadı');
      }
    } catch (err) {
      alert('Bağlantı hatası');
      console.error('Error:', err);
    } finally {
      setPublishing(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleString('tr-TR');
  };

  // Tek bir öğrenciyi mevcut pdf'e render eder, kullandığı son sayfa numarasını döndürür
  async function renderSubmissionToPdf(bodyHTML, pdf, html2canvas, startPageIndex) {
    const { MARGIN, PAGE_H, CONTENT_W, RENDER_PX_W, COL_W, COL_GAP, HALF_PX } = PDF_CONST;

    const container = document.createElement('div');
    container.className = 'pdf-render-root';
    container.style.cssText = [
      'position:fixed', 'left:-9999px', 'top:0',
      `width:${RENDER_PX_W}px`, 'background:white', 'padding:0',
      'box-sizing:border-box', 'z-index:-1'
    ].join(';');
    container.innerHTML = `<style>${PDF_STYLE}</style>${bodyHTML}`;
    document.body.appendChild(container);

    try {
      let currentY = MARGIN;

      // Yeni öğrenci yeni sayfada başlar (ilk öğrenci hariç)
      if (startPageIndex > 0) {
        pdf.addPage();
      }
      const pageOffset = pdf.getNumberOfPages() - 1; // bu öğrencinin 0-indexed ilk sayfası

      // Header → tam genişlik
      const headerEl = container.querySelector('.pdf-header');
      if (headerEl) {
        const hCanvas = await html2canvas(headerEl, { scale: 1.5, useCORS: true, logging: false, width: RENDER_PX_W });
        const hH = (hCanvas.height * CONTENT_W) / hCanvas.width;
        pdf.addImage(hCanvas.toDataURL('image/jpeg', 0.82), 'JPEG', MARGIN, currentY, CONTENT_W, hH);
        currentY += hH + 5;
      }

      // Sorular → her soru HALF_PX genişliğinde render
      const questions = [...container.querySelectorAll('.pdf-question')];
      const rendered = [];
      for (const el of questions) {
        el.style.width = `${HALF_PX}px`;
        el.style.maxWidth = `${HALF_PX}px`;
        rendered.push(await html2canvas(el, { scale: 1.5, useCORS: true, logging: false, width: HALF_PX }));
        el.style.width = '';
        el.style.maxWidth = '';
      }
      const heights = rendered.map(c => (c.height * COL_W) / c.width);

      // Satır bazlı yerleşim (sol+sağ aynı Y)
      let rowY = currentY;
      let rowPage = 0;
      const placements = [];

      for (let i = 0; i < rendered.length; i += 2) {
        const leftH  = heights[i];
        const rightH = i + 1 < rendered.length ? heights[i + 1] : 0;
        const rowH   = Math.max(leftH, rightH);

        if (rowY + rowH > PAGE_H - MARGIN) {
          rowPage++;
          rowY = MARGIN;
        }

        placements.push({ idx: i,     col: 0, page: rowPage, y: rowY });
        if (i + 1 < rendered.length) {
          placements.push({ idx: i + 1, col: 1, page: rowPage, y: rowY });
        }
        rowY += rowH + 3;
      }

      // Gerekli ek sayfaları ekle
      const maxLocalPage = placements.length ? placements[placements.length - 1].page : 0;
      for (let p = 0; p < maxLocalPage; p++) pdf.addPage();

      for (const item of placements) {
        const x = item.col === 0 ? MARGIN : MARGIN + COL_W + COL_GAP;
        pdf.setPage(pageOffset + item.page + 1);
        pdf.addImage(rendered[item.idx].toDataURL('image/jpeg', 0.82), 'JPEG', x, item.y, COL_W, heights[item.idx]);
      }

      return pageOffset + maxLocalPage; // son sayfa index'i
    } finally {
      document.body.removeChild(container);
    }
  }

  async function downloadPDF(bodyHTML, filename) {
    const { default: jsPDF }      = await import('jspdf');
    const { default: html2canvas } = await import('html2canvas');
    const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
    await renderSubmissionToPdf(bodyHTML, pdf, html2canvas, 0);
    pdf.save(`${filename}.pdf`);
  }

  // Görseli base64 data URL'e çevir (html2canvas CORS sorun çıkarmasın)
  async function fetchImageAsDataUrl(url) {
    try {
      const res = await fetch(url);
      if (!res.ok) return null;
      const blob = await res.blob();
      return await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = () => resolve(null);
        reader.readAsDataURL(blob);
      });
    } catch {
      return null;
    }
  }

  async function resolveQuestionImages(questions) {
    // Görsel proxy: same-origin için exam module backend'inden geç
    const MEDIA_BASE = process.env.REACT_APP_QUESTIONS_MEDIA_URL || 'http://localhost:5105';
    const map = {};
    await Promise.all(questions.map(async (q) => {
      if (!q.image_url) return;
      const src = q.image_url.startsWith('http') ? q.image_url : `${MEDIA_BASE}${q.image_url}`;
      const dataUrl = await fetchImageAsDataUrl(src);
      if (dataUrl) map[q.attempt_question_id || q.question_id] = dataUrl;
    }));
    return map;
  }

  async function renderSubmissionHTML(detail, logoUrl = '') {
    const totalPoints = detail.questions
      .reduce((sum, q) => sum + (q.points?.final_points || 0), 0)
      .toFixed(2);

    const LETTERS = ['A', 'B', 'C', 'D', 'E'];

    const imageMap = await resolveQuestionImages(detail.questions);

    const questionsHTML = detail.questions.map((q, i) => {
      let answerHTML = '';

      if (q.question_type === 'MultipleChoice') {
        const options = q.options || {};
        const correctAnswerRaw = (q.correct_answer || '').trim();
        const correctAnswerLetter = correctAnswerRaw.toUpperCase();
        const studentChoice = (q.student_answer?.selected_choice || '').trim().toUpperCase();
        const studentLeftBlank = studentChoice === '';

        const optionsHTML = LETTERS.filter(l => options[l]).map(letter => {
          const optionText = (options[letter] || '').trim();
          const isCorrectLetter = letter === correctAnswerLetter;
          const isCorrectByText = optionText !== '' && correctAnswerRaw !== ''
            && optionText.toLowerCase() === correctAnswerRaw.toLowerCase();
          const isCorrectOption = isCorrectLetter || isCorrectByText;
          const studentChoseThis = letter === studentChoice;

          let style = 'display:block;margin-left:1rem;margin-bottom:4px;padding:3px 8px;border-radius:3px;font-size:9.5pt;font-family:Arial,sans-serif;';
          let marker = `${letter})`;

          if (studentChoseThis && isCorrectOption) {
            // Doğru seçildi → yeşil
            style += 'background:#d4edda;border:2px solid #28a745;font-weight:bold;';
            marker = `${letter}) ✔`;
          } else if (studentChoseThis && !isCorrectOption) {
            // Yanlış seçildi → kırmızı
            style += 'background:#f8d7da;border:2px solid #dc3545;font-weight:bold;';
            marker = `${letter}) ✘`;
          } else if (!studentChoseThis && isCorrectOption && !studentLeftBlank) {
            // Başka şık seçildi, bu doğru cevap → yeşil (seçilmemiş)
            style += 'background:#d4edda;border:2px solid #28a745;';
            marker = `${letter}) ✔`;
          } else if (isCorrectOption && studentLeftBlank) {
            // Boş bırakıldı, bu doğru cevap → sarı
            style += 'background:#fff3cd;border:2px solid #ffc107;';
          } else {
            style += 'border:1px solid transparent;';
          }

          return `<div style="${style}">${marker} ${optionText || ''}</div>`;
        }).join('');

        answerHTML = `<div>${optionsHTML}</div>`;
      } else {
        const text = q.student_answer?.classic_answer_text || '(Boş)';
        answerHTML = `<div class="pdf-classic-answer">${text.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</div>`;
        if (q.correct_answer) {
          answerHTML += `<div class="pdf-correct-label">Doğru cevap: ${q.correct_answer}</div>`;
        }
      }

      const pts = q.points || {};
      const finalPts = parseFloat((pts.final_points || 0).toFixed(2));
      const basePts = parseFloat((q.base_points || 0).toFixed(2));
      const imgDataUrl = imageMap[q.attempt_question_id || q.question_id];
      const imageHTML = imgDataUrl
        ? `<div style="margin:6px 0 8px;text-align:center;"><img src="${imgDataUrl}" style="max-width:90%;max-height:220px;border:1px solid #cbd5e1;border-radius:6px;" /></div>`
        : '';
      return `<div class="pdf-question">
  <div class="pdf-question-topbar">
    <div class="pdf-question-badge">Soru ${i + 1}</div>
    <div class="pdf-question-score">${finalPts} / ${basePts} puan</div>
  </div>
  <div class="pdf-question-text">${(q.question_text || '').replace(/</g, '&lt;').replace(/>/g, '&gt;')}</div>
  ${imageHTML}
  ${answerHTML}
</div>`;
    }).join('');

    const examDateStr = detail.exam_start_at
      ? `${formatDate(detail.exam_start_at)}`
      : (detail.exam_end_at ? formatDate(detail.exam_end_at) : '—');

    return `<div class="pdf-header">
  <div class="pdf-header-top">
    <div class="pdf-univ-block">
      <div class="pdf-univ-name">KOCAELİ SAĞLIK VE TEKNOLOJİ ÜNİVERSİTESİ</div>
      <div class="pdf-univ-sub">Sınav Değerlendirme Belgesi</div>
    </div>
    <div class="pdf-logo-block">
      ${logoUrl ? `<img src="${logoUrl}" alt="logo" />` : ''}
    </div>
  </div>
  <div class="pdf-doc-title">Sınav Kağıdı</div>
  <table class="pdf-meta-table">
    <tr>
      <td class="lbl">Ders</td>
      <td class="val">${detail.course_code ? `${detail.course_code} – ` : ''}${detail.course_name || '—'}</td>
      <td class="lbl">Sınav</td>
      <td class="val">${detail.exam_title || '—'}</td>
    </tr>
    <tr>
      <td class="lbl">Öğrenci No</td>
      <td class="val">${detail.student_number}</td>
      <td class="lbl">Ad Soyad</td>
      <td class="val">${detail.student_full_name || '—'}</td>
    </tr>
    <tr>
      <td class="lbl">Öğretim Üyesi</td>
      <td class="val">${detail.instructor_name || '—'}</td>
      <td class="lbl">Sınav Tarihi</td>
      <td class="val">${examDateStr}</td>
    </tr>
    <tr>
      <td class="lbl">Eğitim-Öğretim Yılı</td>
      <td class="val">${detail.academic_year || '—'}</td>
      <td class="lbl">Dönem</td>
      <td class="val">${detail.donem || '—'}</td>
    </tr>
    <tr>
      <td class="lbl">Teslim Tarihi</td>
      <td class="val">${formatDate(detail.submitted_at)}</td>
      <td class="lbl">Toplam Puan</td>
      <td class="val" style="font-weight:700;font-size:12pt;color:#1a3a5c">${totalPoints}</td>
    </tr>
  </table>
  <div class="pdf-header-band">SORULAR VE CEVAPLAR</div>
</div>
<div>${questionsHTML}</div>`;
  }

  async function handlePrintStudent(attemptId) {
    setPdfLoading(true);
    try {
      const res = await apiFetch(`/instructor/exams/${examId}/submissions/${attemptId}`);
      const data = await res.json();
      if (data.success && data.submission) {
        const html = await renderSubmissionHTML(data.submission, logoImg);
        await downloadPDF(html, `Sinav_Kagidi_${data.submission.student_number}`);
      } else {
        alert('Öğrenci detayı alınamadı.');
      }
    } catch {
      alert('PDF oluşturulurken hata oluştu.');
    } finally {
      setPdfLoading(false);
    }
  }

  async function handlePrintAll() {
    setPdfLoading(true);
    setPdfProgress({ done: 0, total: submissions.length });
    try {
      const { default: jsPDF }       = await import('jspdf');
      const { default: html2canvas } = await import('html2canvas');
      const JSZip                    = (await import('jszip')).default;

      const zip = new JSZip();
      let courseNameForFile = '';
      let examTitleForFile  = '';
      let count = 0;
      let done = 0;

      // API isteklerini paralel çek (en fazla 5 eşzamanlı)
      const BATCH = 5;
      const results = [];
      for (let i = 0; i < submissions.length; i += BATCH) {
        const batch = submissions.slice(i, i + BATCH);
        const batchResults = await Promise.all(
          batch.map(async sub => {
            const res  = await apiFetch(`/instructor/exams/${examId}/submissions/${sub.attempt_id}`);
            const data = await res.json();
            return data.success ? data.submission : null;
          })
        );
        results.push(...batchResults);
      }

      // PDF render sıralı yapılmalı (html2canvas DOM'u paylaşır)
      for (const detail of results) {
        if (!detail) { done++; setPdfProgress({ done, total: submissions.length }); continue; }
        if (!courseNameForFile && detail.course_name) courseNameForFile = detail.course_name;
        if (!examTitleForFile  && detail.exam_title)  examTitleForFile  = detail.exam_title;

        const html = await renderSubmissionHTML(detail, logoImg);
        const pdf  = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
        await renderSubmissionToPdf(html, pdf, html2canvas, 0);

        const safeName = (detail.student_full_name || detail.student_number || `ogrenci_${count + 1}`)
          .replace(/[^a-zA-Z0-9çğışöüÇĞİŞÖÜ ]/g, '_').trim();
        const pdfFilename = `${detail.student_number || count + 1}_${safeName}.pdf`;
        zip.file(pdfFilename, pdf.output('arraybuffer'));
        count++;
        done++;
        setPdfProgress({ done, total: submissions.length });
      }

      if (count === 0) { alert('Hiç kağıt bulunamadı.'); return; }

      const safeCourse = courseNameForFile.replace(/[^a-zA-Z0-9çğışöüÇĞİŞÖÜ]/g, '_').slice(0, 40);
      const safeExam   = examTitleForFile.replace(/[^a-zA-Z0-9çğışöüÇĞİŞÖÜ]/g, '_').slice(0, 40);
      const zipName    = [safeCourse, safeExam, 'Sinav_Kagitlari'].filter(Boolean).join('_') + '.zip';

      const blob = await zip.generateAsync({ type: 'blob' });
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement('a');
      a.href = url; a.download = zipName; a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('PDF hatası:', err);
      alert('PDF oluşturulurken hata oluştu: ' + (err?.message || err));
    } finally {
      setPdfLoading(false);
      setPdfProgress({ done: 0, total: 0 });
    }
  }

  if (loading) {
    return (
      <div className="instructor-grading-container">
        <div className="loading-state">
          <p>Yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="instructor-grading-container">
        <div className="error-state">
          <p>{error}</p>
          {onBack && (
            <button className="btn btn-primary" onClick={onBack}>
              Geri Dön
            </button>
          )}
        </div>
      </div>
    );
  }

  if (selectedSubmission && submissionDetail) {
    // Detay görünümü
    return (
      <div className="instructor-grading-container">
        <div className="grading-header">
          <button className="btn btn-secondary" onClick={() => {
            setSelectedSubmission(null);
            setSubmissionDetail(null);
          }}>
            ← Listeye Dön
          </button>
          <h2>Sınav Kağıdı Detayı</h2>
          <div className="student-info">
            <strong>Öğrenci No:</strong> {submissionDetail.student_number}
          </div>
        </div>

        {submissionDetail.submit_reason === 'reentry' && (
          <div style={{
            margin: '1rem 0',
            padding: '1rem 1.5rem',
            background: '#f3eeff',
            border: '1px solid #6f42c1',
            borderLeft: '4px solid #6f42c1',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.75rem'
          }}>
            <span style={{ fontSize: '1.4rem', lineHeight: 1 }}>↩</span>
            <div>
              <div style={{ fontWeight: '700', color: '#6f42c1', marginBottom: '0.3rem' }}>
                Öğrenciye ihlal sonrası ek giriş hakkı verildi
              </div>
              <div style={{ fontSize: '0.9rem', color: '#555', lineHeight: 1.5 }}>
                Bu öğrenci 2 ihlal yaparak sınavdan atıldı. Akademisyen tarafından tekrar sınav girişi hakkı verildi ve öğrenci sınavını tamamlayarak teslim etti.
              </div>
            </div>
          </div>
        )}

        {submissionDetail.violation_count > 0 && submissionDetail.submit_reason !== 'reentry' && (
          <div style={{
            margin: '1rem 0',
            padding: '1rem 1.5rem',
            background: submissionDetail.submit_reason === 'violation' ? '#fff5f5' : '#fff8f0',
            border: `1px solid ${submissionDetail.submit_reason === 'violation' ? '#dc3545' : '#fd7e14'}`,
            borderLeft: `4px solid ${submissionDetail.submit_reason === 'violation' ? '#dc3545' : '#fd7e14'}`,
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.75rem'
          }}>
            <span style={{ fontSize: '1.4rem', lineHeight: 1 }}>⚠️</span>
            <div>
              <div style={{ fontWeight: '700', color: submissionDetail.submit_reason === 'violation' ? '#dc3545' : '#e65c00', marginBottom: '0.3rem' }}>
                {submissionDetail.submit_reason === 'violation'
                  ? `Sınav, ${submissionDetail.violation_count} ihlal nedeniyle otomatik teslim edildi`
                  : `Sınav sırasında ${submissionDetail.violation_count} ihlal tespit edildi`}
              </div>
              <div style={{ fontSize: '0.9rem', color: '#555', lineHeight: 1.5 }}>
                {submissionDetail.submit_reason === 'violation'
                  ? 'Öğrenci izin verilen ihlal sayısını aştı. Sistem sınavı otomatik olarak sonlandırıp teslim etti.'
                  : 'Öğrenci sınav sırasında sekme değiştirdi, başka bir uygulamaya geçti veya tam ekran modundan çıktı. Sınav normal şekilde teslim edildi.'}
              </div>
              <div style={{ marginTop: '0.5rem', fontSize: '0.85rem', color: '#888' }}>
                İhlal: Sınav sırasında sekme değiştirme, başka uygulamaya/programa geçme veya tam ekran modundan çıkma
              </div>
            </div>
          </div>
        )}

        {loadingDetail ? (
          <div className="loading-state">
            <p>Yükleniyor...</p>
          </div>
        ) : (
          <div className="submission-detail">
            {[...submissionDetail.questions]
              .sort((a, b) => (b.is_mandatory ? 1 : 0) - (a.is_mandatory ? 1 : 0))
              .map((q, index) => {
              const pointPerQ = q.base_points || 0;
              return (
              <div key={q.attempt_question_id} className="question-grading-card">
                <div className="question-grading-header">
                  <h3 style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    Soru {q.order}
                    {q.is_mandatory && (
                      <span style={{
                        background: '#fff0f0',
                        color: '#dc3545',
                        border: '1px solid #dc3545',
                        borderRadius: '12px',
                        fontSize: '0.75rem',
                        padding: '0.15rem 0.6rem',
                        fontWeight: '600'
                      }}>Zorunlu</span>
                    )}
                  </h3>
                  <span style={{
                    background: '#e9ecef',
                    padding: '0.4rem 0.8rem',
                    borderRadius: '4px',
                    fontSize: '0.9rem',
                    fontWeight: '500'
                  }}>
                    Puan: {pointPerQ.toFixed(2)}
                  </span>
                </div>

                <div className="question-grading-content">
                  <div className="question-section">
                    <div className="question-text">
                      <strong>Soru:</strong>
                      <p><MathText text={q.question_text} /></p>
                    </div>

                    {q.question_type === 'Classic' ? (
                      <>
                        <div className="student-answer-section">
                          <strong>Öğrenci Cevabı:</strong>
                          <div className="classic-answer-display">
                            {q.student_answer && q.student_answer.classic_answer_text ? q.student_answer.classic_answer_text : '(Boş)'}
                          </div>
                        </div>
                        <div className="correct-answer-section">
                          <strong>Doğru Cevap:</strong>
                          <div className="correct-answer-display">
                            {q.correct_answer || '(Belirtilmemiş)'}
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        {(!q.correct_answer || q.correct_answer.trim() === '') && (
                          <div className="correct-answer-section" style={{ marginBottom: '1rem' }}>
                            <strong>Doğru Cevabı Belirle:</strong>
                            <div style={{ marginTop: '0.5rem' }}>
                              <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginBottom: '0.75rem' }}>
                                {['A', 'B', 'C', 'D', 'E']
                                  .filter(letter => q.options && (q.options[letter] || '').trim() !== '')
                                  .map(letter => (
                                    <label
                                      key={letter}
                                      style={{
                                        display: 'flex', alignItems: 'center', gap: '0.3rem',
                                        padding: '0.4rem 0.8rem',
                                        border: `2px solid ${correctAnswerEdits[q.question_id] === letter ? '#4CAF50' : '#e0e0e0'}`,
                                        borderRadius: '6px',
                                        background: correctAnswerEdits[q.question_id] === letter ? '#e8f5e9' : '#fff',
                                        cursor: 'pointer',
                                        fontWeight: correctAnswerEdits[q.question_id] === letter ? '700' : '400'
                                      }}
                                    >
                                      <input
                                        type="radio"
                                        name={`correct-answer-${q.question_id}`}
                                        value={letter}
                                        checked={correctAnswerEdits[q.question_id] === letter}
                                        onChange={() =>
                                          setCorrectAnswerEdits(prev => ({ ...prev, [q.question_id]: letter }))
                                        }
                                      />
                                      <span>{letter}: {q.options[letter]}</span>
                                    </label>
                                  ))}
                              </div>
                              <button
                                className="btn btn-primary btn-sm"
                                onClick={() => saveCorrectAnswer(q.question_id, selectedSubmission)}
                                disabled={!correctAnswerEdits[q.question_id] || savingCorrectAnswer[q.question_id]}
                              >
                                {savingCorrectAnswer[q.question_id] ? 'Kaydediliyor...' : 'Doğru Cevabı Kaydet'}
                              </button>
                            </div>
                          </div>
                        )}
                        <div className="all-options-list">
                          <strong>Şıklar:</strong>
                          <div className="options-legend">
                            <span><span className="legend-dot legend-dot--correct-show" /> Doğru cevap</span>
                            <span><span className="legend-dot legend-dot--wrong" /> Yanlış cevaplanan</span>
                            <span><span className="legend-dot legend-dot--correct-blank" /> Cevaplanmamış</span>
                          </div>
                          {['A', 'B', 'C', 'D', 'E'].filter(letter => q.options && (q.options[letter] || '').trim() !== '').map(letter => {
                            const correctAnswerRaw = (q.correct_answer || '').trim();
                            const correctAnswerLetter = correctAnswerRaw.toUpperCase();
                            const studentChoiceRaw = (q.student_answer?.selected_choice || '').trim();
                            const studentChoice = studentChoiceRaw.toUpperCase();
                            const studentLeftBlank = studentChoice === '';
                            const optionText = (q.options[letter] || '').trim();
                            const isCorrectLetter = letter === correctAnswerLetter;
                            const isCorrectByText = optionText !== '' && correctAnswerRaw !== '' && optionText.toLowerCase() === correctAnswerRaw.toLowerCase();
                            const isCorrectOption = isCorrectLetter || isCorrectByText;
                            const studentChoseThis = letter === studentChoice;
                            let rowClass = 'option-row option-row--neutral';
                            if (isCorrectOption && studentChoseThis) rowClass = 'option-row option-row--correct';
                            else if (isCorrectOption && studentLeftBlank) rowClass = 'option-row option-row--correct-blank';
                            else if (isCorrectOption && !studentChoseThis) rowClass = 'option-row option-row--correct-show';
                            else if (studentChoseThis && !isCorrectOption) rowClass = 'option-row option-row--wrong';
                            return (
                              <div key={letter} className={rowClass}>
                                <span className="option-letter">{letter}:</span>
                                <span className="option-text">{q.options[letter]}</span>
                              </div>
                            );
                          })}
                        </div>
                      </>
                    )}
                  </div>

                  <div className="grading-section">
                    <div className="grading-input-group">
                      <label>
                        Puan Ver:
                        <input
                          type="number"
                          min="0"
                          max={pointPerQ}
                          step="0.01"
                          value={grading[q.attempt_question_id] !== null && grading[q.attempt_question_id] !== undefined ? grading[q.attempt_question_id] : ''}
                          onChange={(e) => handleGradeChange(q.attempt_question_id, e.target.value)}
                          placeholder={`0 - ${pointPerQ.toFixed(2)}`}
                        />
                        <span className="max-points">/ {pointPerQ.toFixed(2)}</span>
                      </label>
                    </div>

                    <div className="points-info">
                      {q.question_type === 'MultipleChoice' && (
                        <div className="points-item">
                          <span className="points-label">Hesaplanan:</span>
                          <span className="points-value">
                            {q.points.calculated_points !== null && q.points.calculated_points !== undefined
                              ? parseFloat(q.points.calculated_points).toFixed(2)
                              : '-'}
                          </span>
                        </div>
                      )}
                      <div className="points-item">
                        <span className="points-label">Manuel:</span>
                        <span className="points-value">
                          {grading[q.attempt_question_id] !== null && grading[q.attempt_question_id] !== undefined && grading[q.attempt_question_id] !== ''
                            ? parseFloat(grading[q.attempt_question_id]).toFixed(2)
                            : (q.points.manual_points !== null && q.points.manual_points !== undefined ? q.points.manual_points.toFixed(2) : '-')}
                        </span>
                      </div>
                      <div className="points-item">
                        <span className="points-label">Final:</span>
                        <span className="points-value final">
                          {(() => {
                            const manual = grading[q.attempt_question_id];
                            if (manual !== null && manual !== undefined && manual !== '') return parseFloat(manual).toFixed(2);
                            if (q.points.final_points !== null && q.points.final_points !== undefined) return parseFloat(q.points.final_points).toFixed(2);
                            return '0.00';
                          })()}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              );
            })}

            <div className="submission-summary">
              <div className="summary-item">
                <span className="summary-label">Sınav Notu:</span>
                <span className="summary-value">
                  {(() => {
                    const total = submissionDetail.questions.reduce((sum, q) => {
                      const manual = grading[q.attempt_question_id];
                      if (manual !== null && manual !== undefined && manual !== '') return sum + parseFloat(manual);
                      const fp = q.points.final_points || 0;
                      return sum + fp;
                    }, 0);
                    return total.toFixed(2);
                  })()}
                </span>
              </div>
              <div style={{ marginTop: '1rem', display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
                <button
                  className="btn btn-primary"
                  onClick={() => saveAllGrades(selectedSubmission)}
                  disabled={saving || Object.keys(grading).filter(key => grading[key] !== null && grading[key] !== undefined && grading[key] !== '').length === 0}
                  style={{
                    padding: '0.75rem 1.5rem',
                    fontSize: '1rem',
                    fontWeight: '600'
                  }}
                >
                  {saving ? 'Kaydediliyor...' : 'Tüm Puanları Kaydet'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // Liste görünümü
  const allGraded = submissions.length > 0 && submissions.every(sub => sub.is_graded);

  return (
    <div className="instructor-grading-container">
      <div className="grading-header">
        {onBack && (
          <button className="btn btn-secondary" onClick={onBack}>
            ← Geri Dön
          </button>
        )}
        <h2>Sınav Kağıtları</h2>
        <div className="submissions-search">
          <input
            type="text"
            placeholder="Öğrenci no ile ara..."
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            className="submissions-search-input"
          />
        </div>
        <div className="btn-pdf-wrap">
          <button
            className="btn btn-pdf-all"
            onClick={handlePrintAll}
            disabled={pdfLoading}
            title="Tüm öğrencilerin sınav kağıtlarını tek PDF olarak indir"
          >
            {pdfLoading ? (
              <span className="btn-pdf-inner">
                <span className="btn-pdf-spinner" />
                {pdfProgress.total > 0
                  ? `${pdfProgress.done}/${pdfProgress.total} hazırlanıyor... (${Math.round((pdfProgress.done / pdfProgress.total) * 100)}%)`
                  : 'Hazırlanıyor...'}
              </span>
            ) : (
              <span className="btn-pdf-inner">⬇ Sınav Kağıtlarını İndir (Tümü)</span>
            )}
          </button>
          {pdfLoading && pdfProgress.total > 0 && (
            <div className="pdf-progress-bar-wrap">
              <div
                className="pdf-progress-bar-fill"
                style={{ width: `${Math.round((pdfProgress.done / pdfProgress.total) * 100)}%` }}
              />
              <span className="pdf-progress-bar-pct">
                {Math.round((pdfProgress.done / pdfProgress.total) * 100)}%
              </span>
            </div>
          )}
        </div>
        {allGraded && (
          <button
            className="btn btn-success"
            onClick={publishResults}
            disabled={publishing}
          >
            {publishing ? 'Yayınlanıyor...' : 'Sonuçları Yayınla'}
          </button>
        )}
      </div>

      {submissions.length === 0 ? (
        <div className="empty-state">
          <p>Henüz teslim edilen sınav kağıdı bulunmamaktadır.</p>
        </div>
      ) : (
        <>
        <div className="submissions-table-wrapper">
          <table className="submissions-table">
            <thead>
              <tr>
                <th style={{width:'2.5rem', textAlign:'center'}}>#</th>
                <th>Öğrenci No</th>
                <th>Öğrenci Adı</th>
                <th>Teslim Tarihi</th>
                <th>Puan</th>
                <th>Durum</th>
                <th>İhlal</th>
                <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {submissions.filter(sub => {
                const q = searchQuery.toLowerCase().trim();
                if (!q) return true;
                const inNo = (sub.student_number || '').toLowerCase().includes(q);
                const inName = (sub.student_name || '').toLowerCase().includes(q);
                return inNo || inName;
              }).map((sub, idx) => (
                <tr
                  key={sub.attempt_id}
                  className={`submission-row ${sub.is_graded ? 'graded' : 'not-graded'}`}
                  onClick={() => {
                    setSelectedSubmission(sub.attempt_id);
                    fetchSubmissionDetail(sub.attempt_id);
                  }}
                >
                  <td style={{textAlign:'center', color:'#6b7280', fontSize:'0.85rem', fontWeight:'600'}}>{idx + 1}</td>
                  <td className="student-number">{sub.student_number}</td>
                  <td className="student-name">{sub.student_name || '—'}</td>
                  <td className="submitted-date">{formatDate(sub.submitted_at)}</td>
                  <td className="points">
                    {(sub.total_points || 0).toFixed(2)}
                  </td>
                  <td>
                    <span className={`status-badge ${sub.is_graded ? 'status-graded' : 'status-pending'}`}>
                      {sub.is_graded ? 'Puanlandı' : 'Beklemede'}
                    </span>
                  </td>
                  <td>
                    {sub.submit_reason === 'reentry' ? (
                      <span
                        className="status-badge"
                        style={{ background: '#6f42c1', color: '#fff' }}
                        title="İhlal sonrası akademisyen tarafından tekrar giriş hakkı verildi, öğrenci sınavını tamamladı"
                      >
                        ↩ Ek Hak ile Teslim
                      </span>
                    ) : sub.submit_reason === 'violation' ? (
                      <span
                        className="status-badge"
                        style={{ background: '#dc3545', color: '#fff' }}
                        title={`Sekme/uygulama değiştirme ihlali nedeniyle otomatik teslim edildi (${sub.violation_count} ihlal)`}
                      >
                        ⚠ {sub.violation_count} İhlal
                      </span>
                    ) : sub.violation_count > 0 ? (
                      <span
                        className="status-badge"
                        style={{ background: '#fd7e14', color: '#fff' }}
                        title={`Sınav sırasında ${sub.violation_count} kez sekme/uygulama değiştirildi`}
                      >
                        {sub.violation_count} İhlal
                      </span>
                    ) : (
                      <span style={{ color: '#6c757d', fontSize: '0.85rem' }}>—</span>
                    )}
                  </td>
                  <td className="actions">
                    <button
                      className="btn btn-sm btn-success"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedSubmission(sub.attempt_id);
                        fetchSubmissionDetail(sub.attempt_id);
                      }}
                    >
                      Detay
                    </button>
                    <button
                      className="btn btn-sm btn-pdf-single"
                      onClick={(e) => { e.stopPropagation(); handlePrintStudent(sub.attempt_id); }}
                      disabled={pdfLoading}
                      title="Sınav kağıdını PDF olarak indir"
                      style={{ marginLeft: '0.5rem' }}
                    >
                      ⬇ Sınav Kağıdı
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {searchQuery.trim() !== '' && submissions.filter(sub =>
          sub.student_number.toLowerCase().includes(searchQuery.toLowerCase().trim())
        ).length === 0 && (
          <div className="no-results-message">
            "<span>{searchQuery}</span>" ile eşleşen öğrenci bulunamadı.
          </div>
        )}

        {!allGraded && (
          <div className="mark-all-graded-bar">
            <div className="mark-all-graded-info">
              <span className="mark-all-graded-count">
                {submissions.filter(s => !s.is_graded).length} öğrenci beklemede
              </span>
              <span className="mark-all-graded-desc">
                Değerlendirilmemiş klasik sorulara 0 puan verilerek tüm öğrenciler puanlandı olarak işaretlenir.
              </span>
            </div>
            <button
              className="btn btn-warning mark-all-graded-btn"
              onClick={markAllGraded}
              disabled={markingAllGraded}
            >
              {markingAllGraded ? 'İşleniyor...' : 'Tüm Öğrencileri Puanlandı Olarak İşaretle'}
            </button>
          </div>
        )}
        </>
      )}
    </div>
  );
}

export default InstructorExamGrading;

